/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState } from 'react'
import { useFormik } from 'formik'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useAuth } from '../core/Auth'
import {
  AuthTrustFooter,
  Button,
  FormInput,
  LoadingIndicator,
  PasswordStrengthMeter,
} from '../../../components'
import { ButtonType, showAlert, showError } from '../../../../_metronic/helpers'
import { passwordSchema } from './validation/passwordSchema'
import { useT } from '_metronic/i18n/Metronici18n'
import {
  PasswordDtoChange,
  PasswordDtoReset,
} from 'app/modules/apps/admin/usuarios/usuarios-list/core/_models'
import {
  changePassword,
  resetPasswordUserConfirm,
} from 'app/modules/apps/admin/usuarios/usuarios-list/core/_requests'

export const ResetPassword = () => {
  const { t } = useT()
  const { currentUser, logout } = useAuth()
  const [loading, setLoading] = useState(false)
  const [searchParams] = useSearchParams()
  const token = searchParams.get('token')
  const navigate = useNavigate()

  const initialValues = {
    senha: '',
    confirmaSenha: '',
    senhaAtual: '',
    token: token,
  }

  const formik = useFormik({
    initialValues,
    validationSchema: passwordSchema,
    onSubmit: async (values, { setSubmitting }) => {
      setLoading(true)
      setSubmitting(true)
      try {
        if (token) {
          const data: PasswordDtoReset = {
            token,
            senha: values.senha,
            confirmaSenha: values.confirmaSenha,
          }
          await resetPasswordUserConfirm(data)
        } else if (currentUser) {
          const data: PasswordDtoChange = {
            id: Number(currentUser?.id),
            senhaAtual: values.senhaAtual,
            novaSenha: values.senha,
            confirmaNovaSenha: values.confirmaSenha,
          }
          await changePassword(data)
          // Encerra a sessão emitida com a senha antiga antes de voltar ao login
          await logout()
        } else {
          // Sem token de redefinição e sem sessão ativa não há o que alterar:
          // evita exibir "senha alterada" sem nenhuma chamada ao backend.
          showAlert({
            title: 'Atenção',
            text: 'Não foi possível redefinir a senha: link inválido ou expirado.',
            icon: 'warning',
          })
          return
        }
        navigate('/auth?alter=true')
      } catch (error) {
        showError(error)
      } finally {
        setLoading(false)
        setSubmitting(false)
      }
    },
  })
  return (
    <div>
      <div className='text-start mb-10'>
        <h1 className='text-dark mb-3 fs-2x' data-kt-translate='sign-in-title'>
          Alterar senha
        </h1>
        <div className='text-gray-700 fw-semibold fs-3'>Defina uma nova senha para sua conta.</div>
      </div>
      <form
        className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
        noValidate
        autoComplete='off'
        id='kt_login_signup_form'
        onSubmit={formik.handleSubmit}
      >
        {!token && (
          <FormInput
            formik={formik}
            type='password'
            name='senhaAtual'
            placeholder='Senha atual'
            label='Senha atual'
            className='mb-2'
            isRequired
            autoComplete='new-password'
          />
        )}
        <div className='mb-5'>
          <FormInput
            formik={formik}
            type='password'
            name='senha'
            placeholder='Nova senha'
            label='Nova senha'
            className='mb-2'
            isRequired
            autoComplete='new-password'
          />
          <PasswordStrengthMeter password={formik.values.senha} className='mb-3' />
          <div className='text-muted'>
            Utilize 8 ou mais caracteres com números, letras e caracteres especiais.
          </div>
        </div>

        <FormInput
          formik={formik}
          type='password'
          name='confirmaSenha'
          placeholder='Confirmar senha'
          label='Confirmar senha'
          className='mb-5'
          isRequired
          autoComplete='new-password'
        />

        <Button type={ButtonType.Submit} className='btn-primary btn-auth-full' disabled={loading}>
          {loading ? <LoadingIndicator /> : t('common.send')}
        </Button>
        <AuthTrustFooter />
      </form>
    </div>
  )
}
